<div class="body">

    <div class="headline">
        <span *ngIf="product">
            {{product.productnumber}}
        </span>
        {{item.itemname}}
        <span *ngIf="item.itemcount > 1">
            , {{item.itemcount}} mal
        </span>
    </div>

    <div class="sub-title description">
        {{item.itemdesc}}
    </div>

    <ng-container *ngIf="contract">

        <div class="sub-title contract">
            {{contract.contractnumber}} {{contract.contractdesc}}
        </div>

    </ng-container>

    <ng-container *ngIf="item">

        <div *ngIf="item.itemsetupcost" class="sub-title">
            {{item.itemsetupcost|currency:'EUR':'symbol':'.2-2':'de'}} Einrichtung
        </div>
        <div *ngIf="item.itemsetupcost" class="sub-title">
            {{item.itemrentalcost|currency:'EUR':'symbol':'.2-2':'de'}} Mietkosten
        </div>
        <div *ngIf="item.itemsetupcost" class="sub-title">
            {{item.itempurchasecost|currency:'EUR':'symbol':'.2-2':'de'}} Kosten bei Kauf
        </div>

    </ng-container>

</div>